import React, { useState, useEffect, useRef } from "react";
import {
  FaSearch,
  FaFilter,
  FaCheck,
  FaTimes,
  FaClock,
  FaEye,
  FaClipboardList,
  FaCheckCircle,
  FaTimesCircle,
  FaHourglassHalf,
  FaFileExcel,
  FaDownload,
  FaStar,
  FaRegStar,
} from "react-icons/fa";
import Pagination from "../components/Pagination/Pagination";
import { mission, userEvent } from "../controller";
import Loading from "../components/Loading";
import { use } from "react";
import { FacebookEmbed } from "react-social-media-embed";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

// ...existing imports...

// Component StatCard cho dashboard
const StatCard = ({ title, value, icon, bgColor, textColor }) => (
  <div className={`${bgColor} rounded-lg p-6 shadow-md`}>
    <div className="flex items-center justify-between">
      <div>
        <p className={`${textColor} text-sm font-medium opacity-75`}>{title}</p>
        <p className={`${textColor} text-3xl font-bold`}>{value}</p>
      </div>
      <div className={`${textColor} text-4xl opacity-50`}>{icon}</div>
    </div>
  </div>
);

const admins = [
  // "0847766839",
  "0931845736",
  "0786739638",

  // 15/7/2026
  "0387511326",
  "0961667454",
  "0707993914",
  "0961472908",
  // 16/7/2026
  "0939492047",
  // 16/7/2026
  "0835873749",
  //21/8/2026
  "0795458912",
];

// danh sách đội trưởng
const captains = ["thienlh@hexagon.xyz"];

//danh sách duyệt bài
const adminsMail = ["thienlh@hexagon.xyz"];

// ...rest of your code...

function AdminPage() {
  const isFirstRender = useRef(true);
  const [viewLink, setViewLink] = useState(null); // Thêm state cho popup
  const [team, setTeam] = useState(
    JSON.parse(sessionStorage.getItem("userInfo"))?.userEvent?.team || null
  );
  const [isAdmin, setIsAdmin] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    team: "",
    mission: "",
    search: "",
    searchByMail: "",
    isStarred: "",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });
  const [sortConfig, setSortConfig] = useState({
    field: "updatedAt",
    order: "DESC",
  });
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectSubmissionId, setRejectSubmissionId] = useState(null);
  const [linkSearch, setLinkSearch] = useState("");
  const [linkSearchResults, setLinkSearchResults] = useState([]);
  const [showLinkSearchResults, setShowLinkSearchResults] = useState(false);
  const [linkSearchLoading, setLinkSearchLoading] = useState(false);
  const [showApprovePopup, setShowApprovePopup] = useState(false);
  const [approveSubmissionId, setApproveSubmissionId] = useState(null);
  const [selectedPoints, setSelectedPoints] = useState(null); // 10 hoặc 5
  const [showStarredModal, setShowStarredModal] = useState(false);
  const [starredSubmissions, setStarredSubmissions] = useState([]);
  const [starredLoading, setStarredLoading] = useState(false);
  const [isExportingExcel, setIsExportingExcel] = useState(false);

  // State cho dashboard statistics
  const [statistics, setStatistics] = useState({
    totalCount: 0,
    totalPending: 0,
    totalApproved: 0,
    totalRejected: 0,
  });

  useEffect(() => {
    const userInfoStr = sessionStorage.getItem("userInfo");
    if (!userInfoStr) {
      window.location.href = "/user/events/";
      return;
    }

    const userInfoObj = JSON.parse(userInfoStr);
    if (userInfoObj?.userEvent?.team)
      setFilters((prev) => ({
        ...prev,
        status: "",
        team: userInfoObj?.userEvent?.team,
        mission: "",
        search: "",
        searchByMail: "",
      }));

    if (admins.includes(sessionStorage.getItem("phoneNumber"))) {
      setSuperAdmin(true);
      return;
    }
    if (captains.includes(sessionStorage.getItem("mail"))) {
      setFilters((prev) => ({
        ...prev,
        status: "",
        team: team,
        mission: "",
        search: "",
        searchByMail: "",
      }));
      return;
    }
    // If not admin, redirect to home
    window.location.href = "/"; // Redirect to home if not admin
    // checkIsAdmin();
  }, []);

  // Static data for filter options
  const statusOptions = [
    { value: "", label: "Tất cả trạng thái" },
    { value: "pending", label: "Chờ duyệt" },
    { value: "approved", label: "Đã duyệt" },
    { value: "rejected", label: "Từ chối" },
  ];

  // Fetch submissions
  const fetchSubmissions = async () => {
    try {
      setLoading(true);
      const response = await mission.getSubmission({
        page: pagination.page,
        limit: pagination.limit,
        search: filters.search,
        searchByMail: filters.searchByMail,
        sortField: sortConfig.field,
        sortOrder: sortConfig.order,
        status: filters.status || undefined,
        team: filters.team || undefined,
        mission: filters.mission || undefined,
        isStarred: filters.isStarred ? filters.isStarred === "true" : undefined,
      });

      if (response) {
        setSubmissions(response.submissions || response);

        // Cập nhật thống kê từ API response
        setStatistics({
          totalCount: response.totalCount || 0,
          totalPending: response.totalPending || 0,
          totalApproved: response.totalApproved || 0,
          totalRejected: response.totalRejected || 0,
        });

        // If API returns pagination info, update it
        const totalPages = response.totalCount
          ? Math.ceil(response.totalCount / pagination.limit)
          : 0;
        setPagination((prev) => ({
          ...prev,
          total: response.totalCount,
          totalPages,
        }));
      }
    } catch (error) {
      console.error("Error fetching submissions:", error);
    } finally {
      setLoading(false);
    }
  };

  // Update submission status
  const updateSubmissionStatus = async (id, newStatus, note) => {
    try {
      const response = await mission.updateSubmissionStatus({
        id,
        status: newStatus,
        admin: JSON.parse(sessionStorage.getItem("userInfo")),
        note,
      });
      if (
        response.message === "Submission status updated successfully" ||
        response.message === "Status unchanged"
      ) {
        // Refresh submissions
        fetchSubmissions();
      } else {
        alert("Cập nhật trạng thái không thành công");
      }
    } catch (error) {
      console.error("Error updating submission status:", error);
      alert("Có lỗi xảy ra khi cập nhật trạng thái");
    }
  };

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    if (value != team && !superAdmin && !isAdmin) {
      alert("Bạn không thể lọc đội khác với đội của bạn");
      return;
    }
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
    setPagination((prev) => ({ ...prev, page: 1 })); // Reset to first page
  };

  // Handle sort
  const handleSort = (field) => {
    setSortConfig((prev) => ({
      field,
      order: prev.field === field && prev.order === "DESC" ? "ASC" : "DESC",
    }));
    setPagination((prev) => ({ ...prev, page: 1 })); // Reset to first page
  };

  // Handle pagination
  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  // Show popup when reject button is clicked
  const handleRejectClick = (id) => {
    setRejectSubmissionId(id);
    setShowRejectPopup(true);
    setRejectReason("");
  };

  // Handle confirm reject
  const handleConfirmReject = async () => {
    if (!rejectReason.trim()) {
      alert("Vui lòng nhập lý do trả về!");
      return;
    }
    try {
      const response = await mission.updateSubmissionStatusWithPoints({
        id: rejectSubmissionId,
        status: "rejected",
        admin: JSON.parse(sessionStorage.getItem("userInfo")),
        note: rejectReason,
      });
      if (
        response.message === "Submission status updated successfully" ||
        response.message === "Status unchanged"
      ) {
        fetchSubmissions();
      } else {
        alert("Cập nhật trạng thái không thành công");
      }
    } catch (error) {
      console.error("Error confirming reject:", error);
      alert("Có lỗi xảy ra khi từ chối bài");
    } finally {
      setShowRejectPopup(false);
      setRejectReason("");
      setRejectSubmissionId(null);
    }
  };

  // Handle cancel reject
  const handleCancelReject = () => {
    setShowRejectPopup(false);
    setRejectReason("");
    setRejectSubmissionId(null);
  };

  // Handle approve click — mở popup chọn điểm
  const handleApproveClick = (id) => {
    setApproveSubmissionId(id);
    setSelectedPoints(null);
    setShowApprovePopup(true);
  };

  // Handle cancel approve popup
  const handleCancelApprove = () => {
    setShowApprovePopup(false);
    setSelectedPoints(null);
    setApproveSubmissionId(null);
  };

  // Handle confirm approve với điểm đã chọn
  const handleConfirmApprove = async () => {
    if (!selectedPoints) {
      alert("Vui lòng chọn số điểm trước khi duyệt!");
      return;
    }
    try {
      const response = await mission.updateSubmissionStatusWithPoints({
        id: approveSubmissionId,
        status: "approved",
        admin: JSON.parse(sessionStorage.getItem("userInfo")),
        pointsAwarded: selectedPoints,
      });
      if (
        response.message === "Submission status updated successfully" ||
        response.message === "Status unchanged"
      ) {
        fetchSubmissions();
      } else {
        alert("Cập nhật trạng thái không thành công");
      }
    } catch (error) {
      console.error("Error confirming approve:", error);
      alert("Có lỗi xảy ra khi duyệt bài");
    } finally {
      setShowApprovePopup(false);
      setSelectedPoints(null);
      setApproveSubmissionId(null);
    }
  };

  // Handle toggle star for a submission
  const handleToggleStar = async (id, currentStarredState) => {
    const newStarred = !currentStarredState;
    // Optimistic update cho bảng chính
    setSubmissions((prev) =>
      prev.map((s) => (s.id === id ? { ...s, isStarred: newStarred } : s))
    );
    // Optimistic update cho danh sách starred modal nếu đang mở
    setStarredSubmissions((prev) => {
      if (!newStarred) {
        return prev.filter((s) => s.id !== id);
      }
      return prev.map((s) => (s.id === id ? { ...s, isStarred: newStarred } : s));
    });

    try {
      const adminInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      await mission.toggleSubmissionStar({
        id,
        isStarred: newStarred,
        admin: adminInfo,
      });
    } catch (error) {
      console.error("Error toggling star:", error);
      // Rollback nếu lỗi
      setSubmissions((prev) =>
        prev.map((s) => (s.id === id ? { ...s, isStarred: currentStarredState } : s))
      );
    }
  };

  // Function mở Modal Danh sách Bài đã Ghim riêng
  const handleOpenStarredModal = async () => {
    setShowStarredModal(true);
    try {
      setStarredLoading(true);
      const response = await mission.getSubmission({
        page: 1,
        limit: 100,
        isStarred: true,
      });
      if (response) {
        setStarredSubmissions(response.submissions || response || []);
      }
    } catch (err) {
      console.error("Error fetching starred submissions:", err);
    } finally {
      setStarredLoading(false);
    }
  };

  // Search submissions by link
  const searchSubmissionsByLink = async (link) => {
    if (!link.trim()) {
      setLinkSearchResults([]);
      setShowLinkSearchResults(false);
      return;
    }

    try {
      setLinkSearchLoading(true);
      const response = await mission.getSubmissionByLink({
        link: link.trim(),
        event: "minigameVhu30",
      });

      if (response && response.submissions) {
        setLinkSearchResults(response.submissions);
        setShowLinkSearchResults(true);
      } else {
        setLinkSearchResults([]);
        setShowLinkSearchResults(false);
      }
    } catch (error) {
      console.error("Error searching submissions:", error);
      setLinkSearchResults([]);
      setShowLinkSearchResults(false);
    } finally {
      setLinkSearchLoading(false);
    }
  };

  // Handle link search input change with debounce
  const handleLinkSearchChange = (value) => {
    setLinkSearch(value);
  };

  // Debounced search effect
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchSubmissionsByLink(linkSearch);
    }, 2000); // 2 seconds delay

    return () => clearTimeout(timeoutId);
  }, [linkSearch]);

  // Helper functions
  const getStatusText = (status) => {
    switch (status) {
      case "approved":
        return "Đã duyệt";
      case "pending":
        return "Chờ duyệt";
      case "rejected":
        return "Từ chối";
      default:
        return status;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "text-green-600 bg-green-100";
      case "pending":
        return "text-yellow-600 bg-yellow-100";
      case "rejected":
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "approved":
        return <FaCheck className="text-green-600" />;
      case "pending":
        return <FaClock className="text-yellow-600" />;
      case "rejected":
        return <FaTimes className="text-red-600" />;
      default:
        return null;
    }
  };

  const getMissionName = (mission) => {
    return `Nhiệm vụ ${mission}`;
  };

  const getPoints = (mission, status) => {
    if (status !== "approved") return 0;
    const pointsMap = { 1: 20, 2: 10, 3: 5, 4: 2 };
    return pointsMap[mission] || 0;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const dateVN = date.toLocaleDateString("vi-VN", {
      timeZone: "Asia/Ho_Chi_Minh",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const timeVN = date.toLocaleTimeString("vi-VN", {
      timeZone: "Asia/Ho_Chi_Minh",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    return `${dateVN} ${timeVN}`;
  };

  // Effects
  useEffect(() => {
    if (!filters.team && !superAdmin) {
      return; // Redirect to home if not admin
    }

    if (isFirstRender.current) {
      isFirstRender.current = false;
      fetchSubmissions();
      return;
    }

    const timer = setTimeout(() => {
      fetchSubmissions();
    }, 500);

    return () => clearTimeout(timer);
  }, [pagination.page, pagination.limit, filters, sortConfig, superAdmin]);

  const exportLogsToExcel = async () => {
    try {
      setIsExportingExcel(true);
      const response = await fetch(`${mission.exportLogsExcel}?event=minigameVhu30`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      });
      if (!response.ok) {
        throw new Error("Export failed with status " + response.status);
      }
      const blob = await response.blob();
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
      const filename = `submissions_${timestamp}.xlsx`;
      saveAs(blob, filename);
    } catch (error) {
      console.error("Error exporting excel:", error);
      alert("Có lỗi xảy ra khi xuất file Excel");
    } finally {
      setIsExportingExcel(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0253e1] to-[#25c8ff] p-6 font-montserrat">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white/20 rounded-3xl px-6 py-8 mb-8 shadow-lg">
          <h1 className="text-4xl font-bold text-center text-white mb-2">
            QUẢN LÝ BÀI DỰ THI
          </h1>
          <p className="text-center text-white/80">
            Duyệt và quản lý các bài nộp từ người dùng
          </p>
        </div>

        {/* Dashboard Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <StatCard
            title="Tổng bài viết"
            value={statistics.totalCount}
            icon={<FaClipboardList />}
            bgColor="bg-gradient-to-r from-blue-500 to-blue-600"
            textColor="text-white"
          />
          <StatCard
            title="Chờ duyệt"
            value={statistics.totalPending}
            icon={<FaHourglassHalf />}
            bgColor="bg-gradient-to-r from-yellow-500 to-orange-500"
            textColor="text-white"
          />
          <StatCard
            title="Đã duyệt"
            value={statistics.totalApproved}
            icon={<FaCheckCircle />}
            bgColor="bg-gradient-to-r from-green-500 to-green-600"
            textColor="text-white"
          />
          <StatCard
            title="Đã từ chối"
            value={statistics.totalRejected}
            icon={<FaTimesCircle />}
            bgColor="bg-gradient-to-r from-red-500 to-red-600"
            textColor="text-white"
          />
        </div>

        {/* Export Controls */}
        <div className="bg-white/20 rounded-3xl px-6 py-4 mb-8 shadow-lg">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-3">
              <FaFileExcel className="text-white text-xl" />
              <div>
                <h3 className="text-white font-bold text-lg">Xuất dữ liệu</h3>
                <p className="text-white/70 text-sm">
                  Tải xuống dữ liệu bài nộp dưới dạng Excel
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={handleOpenStarredModal}
                className="flex items-center gap-2 bg-gradient-to-r from-yellow-500 to-amber-600 hover:from-yellow-600 hover:to-amber-700 text-white px-5 py-3 rounded-lg font-medium transition-all duration-200 transform hover:scale-105 shadow-lg"
              >
                <FaStar className="text-lg" />
                <span>Bài đã ghim ⭐</span>
              </button>
              <button
                onClick={() => exportLogsToExcel()}
                disabled={isExportingExcel}
                className="flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-lg font-medium transition-all duration-200 transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <FaDownload className="text-lg" />
                <span>{isExportingExcel ? "Đang xuất..." : "Xuất Excel"}</span>
              </button>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-white/20 rounded-3xl px-6 py-6 mb-8 shadow-lg">
          <div className="flex items-center gap-4 mb-4">
            <FaFilter className="text-white text-xl" />
            <h2 className="text-xl font-bold text-white">BỘ LỌC</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            {/* Status Filter */}
            <div>
              <label className="block text-white font-medium mb-2">
                Trạng thái
              </label>
              <select
                value={filters.status}
                onChange={(e) => handleFilterChange("status", e.target.value)}
                className="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {statusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Starred Filter */}
            <div>
              <label className="block text-white font-medium mb-2">Ghim sao ⭐</label>
              <select
                value={filters.isStarred}
                onChange={(e) => handleFilterChange("isStarred", e.target.value)}
                className="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Tất cả bài</option>
                <option value="true">⭐ Chỉ bài đã ghim</option>
                <option value="false">Chưa ghim sao</option>
              </select>
            </div>

            {/* Search */}
            <div>
              <label className="block text-white font-medium mb-2">
                Tìm kiếm link
              </label>
              <div className="relative">
                <input
                  // disabled={ !superAdmin}
                  type="text"
                  value={filters.search}
                  onChange={(e) => handleFilterChange("search", e.target.value)}
                  placeholder="Nhập link để tìm kiếm..."
                  className="w-full px-3 py-2 pl-10 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              </div>
            </div>

            {/* Search by Mail/Name */}
            <div>
              <label className="block text-white font-medium mb-2">
                Tìm kiếm Email / Tên
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="searchByMail"
                  value={filters.searchByMail}
                  onChange={(e) => handleFilterChange("searchByMail", e.target.value)}
                  placeholder="Nhập email hoặc tên..."
                  className="w-full px-3 py-2 pl-10 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              </div>
            </div>
          </div>
        </div>

        {/* Link Search Section */}
        <div
        // className="bg-white/20 rounded-3xl px-6 py-6 mb-8 shadow-lg"
        >
          {/* <div className="flex items-center gap-4 mb-4">
            <FaSearch className="text-white text-xl" />
            <h2 className="text-xl font-bold text-white">TÌM KIẾM THEO LINK</h2>
          </div>

          <div className="relative">
            <input
              type="text"
              value={linkSearch}
              onChange={(e) => handleLinkSearchChange(e.target.value)}
              placeholder="Nhập link để tìm kiếm bài nộp..."
              className="w-full px-4 py-3 pl-12 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800"
            />
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            {linkSearchLoading && (
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
              </div>
            )}
          </div> */}

          {/* Search Results */}
          {/* {showLinkSearchResults && (
            <div className="mt-4 bg-white rounded-lg shadow-lg max-h-96 overflow-y-auto">
              {linkSearchResults.length > 0 ? (
                <div className="p-4">
                  <h3 className="text-lg font-bold text-gray-800 mb-3">
                    Kết quả tìm kiếm ({linkSearchResults.length} bài)
                  </h3>
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-3 py-2 text-left text-gray-600 font-semibold text-sm">
                            ID
                          </th>
                          <th className="px-3 py-2 text-left text-gray-600 font-semibold text-sm">
                            Nhiệm vụ
                          </th>
                          <th className="px-3 py-2 text-left text-gray-600 font-semibold text-sm">
                            Đội
                          </th>
                          <th className="px-3 py-2 text-left text-gray-600 font-semibold text-sm">
                            Người chơi
                          </th>
                          <th className="px-3 py-2 text-center text-gray-600 font-semibold text-sm">
                            Trạng thái
                          </th>
                          <th className="px-3 py-2 text-center text-gray-600 font-semibold text-sm">
                            Điểm
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {linkSearchResults.map((submission, index) => (
                          <tr
                            key={submission.id}
                            className={
                              index % 2 === 0 ? "bg-gray-50" : "bg-white"
                            }
                          >
                            <td className="px-3 py-2 text-gray-800 text-sm">
                              #{submission.id}
                            </td>
                            <td className="px-3 py-2 text-gray-800 text-sm">
                              {getMissionName(submission.mission)}
                            </td>
                            <td className="px-3 py-2 text-gray-800 text-sm">
                              {submission.team}
                            </td>
                            <td className="px-3 py-2 text-gray-800 text-sm">
                              {submission.userEventPhone || "Chưa có"}
                            </td>
                            <td className="px-3 py-2 text-center">
                              <div className="flex items-center justify-center">
                                {getStatusIcon(submission.status)}
                                <span
                                  className={`ml-1 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                                    submission.status
                                  )}`}
                                >
                                  {getStatusText(submission.status)}
                                </span>
                              </div>
                            </td>
                            <td className="px-3 py-2 text-center text-gray-800 font-bold text-sm">
                              {submission.pointsAwarded ?? "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="p-4 text-center text-gray-600">
                  Không tìm thấy bài nộp nào với link này
                </div>
              )}
            </div>
          )} */}
        </div>

        {/* Submissions Table */}
        <div className="bg-white/20 rounded-3xl px-6 py-6 shadow-lg">
          {loading ? (
            <Loading></Loading>
          ) : submissions.length > 0 ? (
            <>
              <div className="overflow-x-auto">
                <table className="w-full bg-white rounded-lg overflow-hidden">
                  <thead className="bg-gradient-to-r from-[#0253e1] to-[#25c8ff]">
                    <tr>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        ID
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold ">
                        Nhiệm vụ
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        Đội
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        Người chơi
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        Link
                      </th>
                      <th className="px-4 py-3 text-center text-white font-bold">
                        Trạng thái
                      </th>
                      <th className="px-4 py-3 text-center text-white font-bold">
                        Điểm
                      </th>
                      <th
                        className="px-4 py-3 text-center text-white font-bold cursor-pointer hover:bg-white/10"
                        onClick={() => handleSort("updatedAt")}
                      >
                        Cập nhật{" "}
                        {sortConfig.field === "updatedAt" &&
                          (sortConfig.order === "DESC" ? "↓" : "↑")}
                      </th>
                      <th className="px-4 py-3 text-center text-white font-bold">
                        Thao tác
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {submissions.map((submission, index) => (
                      <tr
                        key={submission.id}
                        className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                      >
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleToggleStar(
                                  submission.id,
                                  submission.isStarred
                                )
                              }
                              className="text-lg focus:outline-none transition-transform hover:scale-125"
                              title={
                                submission.isStarred
                                  ? "Bỏ ghim sao"
                                  : "Ghim sao bài này"
                              }
                            >
                              {submission.isStarred ? (
                                <FaStar className="text-yellow-400 drop-shadow" />
                              ) : (
                                <FaRegStar className="text-gray-300 hover:text-yellow-400" />
                              )}
                            </button>
                            <span>#{submission.id}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          {getMissionName(submission.mission)}
                        </td>
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          {submission.userEventDonvi || "Chưa có đội"}
                        </td>
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          {submission.userEventName || "Chưa có người chơi"}
                        </td>
                        <td className="px-4 py-3">
                          <a
                            href={submission.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline break-all text-sm max-w-xs block truncate"
                            title={submission.link}
                          >
                            {submission.link}
                          </a>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <div className="flex items-center justify-center gap-2">
                            {getStatusIcon(submission.status)}
                            <span
                              className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                submission.status
                              )}`}
                            >
                              {getStatusText(submission.status)}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-center font-bold text-gray-800">
                          {submission.pointsAwarded ?? "-"}
                        </td>
                        <td className="px-4 py-3 text-center text-sm text-gray-600">
                          {formatDate(submission.updatedAt)}
                        </td>
                        <td className="px-4 py-3 text-center">
                          {(isAdmin || superAdmin) && (
                            <div className="flex gap-2 justify-center">
                              {submission.status !== "approved" && (
                                <button
                                  onClick={() => handleApproveClick(submission.id)}
                                  className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm transition"
                                  title="Duyệt"
                                >
                                  <FaCheck />
                                </button>
                              )}
                              {submission.status !== "rejected" && (
                                <button
                                  onClick={() =>
                                    handleRejectClick(submission.id)
                                  }
                                  className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm transition"
                                  title="Từ chối"
                                >
                                  <FaTimes />
                                </button>
                              )}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="mt-6 flex justify-center">
                <Pagination
                  currentPage={pagination.page}
                  totalPages={pagination.totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </>
          ) : (
            <div className="text-center text-white text-lg py-8">
              Không có submission nào
            </div>
          )}
        </div>
      </div>
      {/* POPUP XEM BÀI VIẾT */}
      {viewLink && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full relative p-4">
            <button
              className="absolute top-2 right-4 text-2xl text-gray-600 hover:text-red-500"
              onClick={() => setViewLink(null)}
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-[#0253e1]">
              Xem bài viết
            </h2>
            <div className="w-full h-[70vh]">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <FacebookEmbed url={viewLink} width={550} />
              </div>
            </div>
          </div>
        </div>
      )}
      {/* POPUP LÝ DO TRẢ VỀ */}
      {showRejectPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative">
            <button
              className="absolute top-2 right-4 text-2xl text-gray-600 hover:text-red-500"
              onClick={handleCancelReject}
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-[#e11d48] text-center">
              Nhập lý do trả về
            </h2>
            <textarea
              className="w-full border border-gray-300 rounded-lg p-3 mb-4 text-gray-800 focus:outline-none focus:ring-2 focus:ring-red-400"
              rows={4}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Nhập lý do trả về..."
            />
            <div className="flex gap-4">
              <button
                onClick={handleCancelReject}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Hủy
              </button>
              <button
                onClick={handleConfirmReject}
                className="flex-1 px-4 py-2 bg-gradient-to-r from-[#e11d48] to-[#f87171] text-white rounded-lg hover:opacity-90 transition-opacity"
              >
                Xác nhận
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Approve Popup — Chọn điểm */}
      {showApprovePopup && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl">
            <h3 className="text-lg font-bold text-gray-800 mb-1">Duyệt bài nộp</h3>
            <p className="text-sm text-gray-500 mb-5">Chọn số điểm để trao cho người nộp:</p>

            <div className="flex gap-3 mb-6">
              <button
                onClick={() => setSelectedPoints(10)}
                className={`flex-1 py-4 rounded-xl text-lg font-bold border-2 transition ${selectedPoints === 10
                  ? "bg-green-500 text-white border-green-500 shadow-lg scale-105"
                  : "bg-white text-green-600 border-green-300 hover:border-green-500"
                  }`}
              >
                10 điểm
              </button>
              <button
                onClick={() => setSelectedPoints(5)}
                className={`flex-1 py-4 rounded-xl text-lg font-bold border-2 transition ${selectedPoints === 5
                  ? "bg-blue-500 text-white border-blue-500 shadow-lg scale-105"
                  : "bg-white text-blue-600 border-blue-300 hover:border-blue-500"
                  }`}
              >
                5 điểm
              </button>
            </div>

            <div className="flex gap-3">
              <button
                onClick={handleCancelApprove}
                className="flex-1 py-2 rounded-xl border border-gray-300 text-gray-600 font-medium hover:bg-gray-50 transition"
              >
                Hủy
              </button>
              <button
                onClick={handleConfirmApprove}
                disabled={!selectedPoints}
                className={`flex-1 py-2 rounded-xl font-bold text-white transition ${selectedPoints
                  ? "bg-green-500 hover:bg-green-600"
                  : "bg-gray-300 cursor-not-allowed"
                  }`}
              >
                Xác nhận duyệt
              </button>
            </div>
          </div>
        </div>
      )}
      {/* MODAL DANH SÁCH BÀI ĐÃ GHIM SAO */}
      {showStarredModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[85vh] flex flex-col relative overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-amber-500 to-yellow-500 text-white">
              <div className="flex items-center gap-2 font-bold text-xl">
                <FaStar className="text-yellow-200" />
                <h2>DANH SÁCH BÀI DỰ THI ĐÃ GHIM SAO</h2>
              </div>
              <button
                className="text-2xl text-white hover:text-red-200 transition-colors font-bold"
                onClick={() => setShowStarredModal(false)}
              >
                &times;
              </button>
            </div>

            {/* Body / Content */}
            <div className="p-6 overflow-y-auto flex-1">
              {starredLoading ? (
                <div className="py-12">
                  <Loading />
                </div>
              ) : starredSubmissions.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="w-full bg-white rounded-lg overflow-hidden border border-gray-200">
                    <thead className="bg-gray-100 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-3 text-left text-gray-700 font-bold text-sm">
                          ID
                        </th>
                        <th className="px-4 py-3 text-left text-gray-700 font-bold text-sm">
                          Nhiệm vụ
                        </th>
                        <th className="px-4 py-3 text-left text-gray-700 font-bold text-sm">
                          Người nộp
                        </th>
                        <th className="px-4 py-3 text-left text-gray-700 font-bold text-sm">
                          Link bài thi
                        </th>
                        <th className="px-4 py-3 text-center text-gray-700 font-bold text-sm">
                          Trạng thái
                        </th>
                        <th className="px-4 py-3 text-center text-gray-700 font-bold text-sm">
                          Điểm
                        </th>
                        <th className="px-4 py-3 text-center text-gray-700 font-bold text-sm">
                          Thao tác
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {starredSubmissions.map((submission, index) => (
                        <tr
                          key={submission.id}
                          className={
                            index % 2 === 0
                              ? "bg-gray-50 hover:bg-amber-50/40"
                              : "bg-white hover:bg-amber-50/40"
                          }
                        >
                          <td className="px-4 py-3 text-gray-800 font-medium text-sm">
                            <div className="flex items-center gap-1">
                              <FaStar className="text-yellow-400" />
                              <span>#{submission.id}</span>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-gray-800 font-medium text-sm">
                            {getMissionName(submission.mission)}
                          </td>
                          <td className="px-4 py-3 text-gray-800 text-sm">
                            <div className="font-medium">
                              {submission.userEventName || "Chưa có tên"}
                            </div>
                            <div className="text-xs text-gray-500">
                              {submission.userPhoneNumber ||
                                submission.userEventPhone ||
                                ""}
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <a
                              href={submission.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800 underline break-all max-w-xs block truncate"
                              title={submission.link}
                            >
                              {submission.link}
                            </a>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <div className="flex items-center justify-center gap-1">
                              {getStatusIcon(submission.status)}
                              <span
                                className={`px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                                  submission.status
                                )}`}
                              >
                                {getStatusText(submission.status)}
                              </span>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800 text-sm">
                            {submission.pointsAwarded ?? "-"}
                          </td>
                          <td className="px-4 py-3 text-center">
                            <button
                              onClick={() =>
                                handleToggleStar(submission.id, true)
                              }
                              className="bg-amber-100 hover:bg-amber-200 text-amber-800 border border-amber-300 px-3 py-1 rounded text-xs font-medium transition flex items-center gap-1 mx-auto"
                              title="Bỏ ghim sao"
                            >
                              <FaStar className="text-yellow-500" />
                              <span>Bỏ ghim</span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center text-gray-500 py-12 text-base">
                  Chưa có bài thi nào được ghim sao ⭐
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="px-6 py-3 bg-gray-50 border-t border-gray-200 flex justify-end">
              <button
                onClick={() => setShowStarredModal(false)}
                className="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium rounded-lg transition-colors"
              >
                Đóng
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPage;
